import { useDispatch, useSelector } from "react-redux"
import Button from "../../../common/Button"
import { filterActions } from "../../../../store/filter"
import { historyActions } from "../../../../store/history"
import { exportsActions } from "../../../../store/exports"
import { referralsActions } from "../../../../store/referrals"
import { tasksActions } from "../../../../store/tasks"
import { transfersActions } from "../../../../store/transfers"
import { appointmentsActions } from "../../../../store/appointments"

const SLICE_ACTIONS = {
    history: historyActions,
    exports: exportsActions,
    referrals: referralsActions,
    tasks: tasksActions,
    transfers: transfersActions,
    appointments: appointmentsActions,
}


const PaginationButton = ({children, page, isDisabled, apiType, type}) => {
    const dispatch = useDispatch()   

    const loading = useSelector(state => state[SLICE_ACTIONS[apiType] ? apiType : 'filter'].loading)
    let requesterId = 'page_requester_id_' + type + '_' + page?.split('=').pop()
    const requesterIdStored = useSelector(state => state[SLICE_ACTIONS[apiType] ? apiType : 'filter'].requesterId)


    const goToPage = async (link) => {
        const page = link.split('=').pop()
        if (apiType == 'history') {
            dispatch(historyActions.setCurrentPage(page))
            dispatch(historyActions.setRequesterId(requesterId))
        } else if (apiType == 'exports') {
            dispatch(exportsActions.setCurrentPage(page))
            dispatch(exportsActions.setRequesterId(requesterId))
        } else if (apiType == 'referrals') {
            dispatch(referralsActions.setCurrentPage(page))
            dispatch(referralsActions.setRequesterId(requesterId))
        } else if (apiType == 'tasks') {
            dispatch(tasksActions.setCurrentPage(page))
            dispatch(tasksActions.setRequesterId(requesterId))
        } else if (apiType == 'transfers') {
            dispatch(transfersActions.setCurrentPage(page))
            dispatch(transfersActions.setRequesterId(requesterId))
        } else if (apiType == 'appointments') {
            dispatch(appointmentsActions.setCurrentPage(page))
            dispatch(appointmentsActions.setRequesterId(requesterId))
        } else {    
            dispatch(filterActions.setCurrentPage(page))
            dispatch(filterActions.setRequesterId(requesterId))
        }
    }

    return <>
        <Button click={() => { goToPage(page)}} isDisabled={isDisabled} isLoading={loading && requesterIdStored == requesterId}>{children}</Button>
    </>

}

export default PaginationButton